/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneSmartBanner from 'base/components/standalone/SmartBanner';

export const DynamicStandaloneSmartBanner = StandaloneSmartBanner;
export type DynamicStandaloneSmartBannerProps = PropsFromComponent<typeof StandaloneSmartBanner>;

export const DynamicStandaloneSmartBannerWith = (extras: DynamicStandaloneExtras): typeof StandaloneSmartBanner => {
    return function DynamicStandaloneSmartBanner(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'SmartBanner');
        return <StandaloneSmartBanner {...mergeProps({ options: { theme } }, props)} />;
    }
}